export enum PaymentAdjustmentType {
    PROMOTION = 'PROMOTION',
    DISCOUNT_CODE = 'DISCOUNT_CODE',
    AGENCY_COMMISSION = 'AGENCY_COMMISSION',
    TAX = 'TAX'
}